<template>
    <div class="renderPage animate-fade-in canjear-container">
        <!-- Header Section -->
        <v-toolbar color="primary" dark flat class="mb-2 rounded-xl">
            <v-icon class="mr-2" size="24">mdi-coin</v-icon>
            <v-toolbar-title class="text-subtitle-1 text-sm-h5 font-weight-black px-0">
                CANJEAR PREMIOS
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <!-- Table View -->
        <v-card class="rounded-xl overflow-hidden glass-card elevation-2">
            <!-- Removed accent from here to avoid double bars if needed, or keep for consistency -->
            <!-- <div class="card-accent-gradient"></div> -->
            <v-data-table 
                :headers="headers" 
                :items="items"
                class="premium-table"
                mobile-breakpoint="0"
                no-data-text="No hay premios pendientes"
            >
                <template v-slot:[`item.sorteoNombre`]="{ item }">
                    <div class="d-flex flex-column py-2">
                        <span class="text-subtitle-2 font-weight-bold">{{ item.sorteoNombre }}</span>
                        <span class="text-xxs grey--text">Tiquete #{{ item.idTiquete }}</span>
                        <span class="text-caption grey--text text--darken-1 d-md-none mt-1" style="max-width: 150px; line-height: 1.1;">
                            {{ item.detalle }}
                        </span>
                    </div>
                </template>

                <template v-slot:[`item.nombreCliente`]="{ item }">
                    <span class="text-subtitle-2 font-weight-medium text-truncate d-inline-block" style="max-width: 120px;">
                        {{ item.nombreCliente || 'General' }}
                    </span>
                </template>

                <template v-slot:[`item.total`]="{ item }">
                    <span class="success--text font-weight-black">₡{{ item.total }}</span>
                </template>

                <template v-slot:[`item.detalle`]="{ item }">
                    <span class="text-caption grey--text text--darken-1" style="min-width: 200px; display: inline-block;">
                        {{ item.detalle }}
                    </span>
                </template>

                <template v-slot:[`item.fechaString`]="{ item }">
                    <span class="text-caption grey--text">{{ item.fechaString }}</span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                        <v-btn 
                            color="primary" 
                            class="rounded-lg elevation-2 font-weight-bold"
                            small
                            @click="editItem(item)"
                        >
                            <v-icon left small>mdi-cash</v-icon>
                            <span class="d-none d-sm-inline">Canjear</span>
                        </v-btn>
                </template>
            </v-data-table>
        </v-card>

        <!-- Empty State (Conditional) -->
        <v-row v-if="items.length === 0" justify="center" class="mt-12">
            <v-col cols="12" md="6" class="text-center">
                <div class="empty-state-container pa-8 rounded-xl glass-card mx-auto" style="max-width: 400px;">
                    <v-icon size="80" color="grey lighten-2" class="mb-4">mdi-gift</v-icon>
                    <h3 class="text-h6 font-weight-bold grey--text text--darken-1">Todo al día</h3>
                    <p class="text-caption grey--text mt-2">No tienes premios pendientes por canjear en este momento.</p>
                </div>
            </v-col>
        </v-row>

        <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Snackbar from "./shared/Snackbar.vue";

export default {
    components: {
        Snackbar,
    },
    data() {
        return {
            snackText: "",
            snackValue: false,
            fecha: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
            items: [],
            editedItem: [],
            usuarios: [],
            headers: [
                { text: "Sorteo / Tiquete", align: "start", value: "sorteoNombre" },
                { text: "Cliente", align: "start", value: "nombreCliente" },
                { text: "Monto", align: "start", value: "total" },
                { text: "Detalle", align: "start", value: "detalle", class: "d-none d-md-table-cell", cellClass: "d-none d-md-table-cell" },
                { text: "Fecha", align: "start", value: "fechaString", class: "d-none d-sm-table-cell", cellClass: "d-none d-sm-table-cell" },
                { text: "Acción", value: "actions", sortable: false, align: "center" },
            ],
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    created() {
        this.getUsuariosPorCia();
        this.getPremiosAll();
    },

    methods: {
        getPremiosAll() {
            let me = this;
            axios
                .get(
                    "api/Tiempos/GetPremiosAll?fecha=" +
                    this.fecha.toString() +
                    "&companyId=" +
                    this.strCia +
                    "&idUsuario=" +
                    me.user.cedula,
                )
                .then(function (response) {
                    me.items = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getUsuariosPorCia() {
            let me = this;
            axios
                .get(
                    "api/Usuarios/getUsuariosPorCia?companyId=" +
                    this.strCia,
                )
                .then(function (response) {
                    me.usuarios = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        cerrarSorteoAutomatico() {
            let me = this;
            axios
                .get(
                    "api/Tiempos/CerrarSorteosAutomatico"
                )
                .then(function () {
                    me.getPremiosAll();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        closed() {
            this.customerModal = false;
        },

        editItem(item) {
            this.snackValue = false;
            this.editedItem = Object.assign({}, item);
            let me = this;
            if (confirm("¿Está seguro de que desea canjear el premio?")) {
                axios
                    .post("api/Tiempos/CanjearPremio", this.editedItem)
                    .then(function (response) {
                        if (response.data) {
                            me.snackText = "¡Premio canjeado con éxito!";
                            me.snackValue = true;
                            me.getPremiosAll();
                        } else {
                            me.snackText = "Error al canjear el premio";
                            me.snackValue = true;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
    },
};
</script>

<style scoped>
.canjear-container {
    padding: 16px;
    padding-bottom: 80px;
}

.text-xxs {
    font-size: 0.7rem;
}

.card-accent-gradient {
    height: 3px;
    background: linear-gradient(90deg, #1e88e5, #00acc1);
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.03) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.7rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.premium-toolbar {
    background: rgba(255, 255, 255, 0.4) !important;
    backdrop-filter: blur(10px);
}

.theme--dark .premium-toolbar {
    background: rgba(30, 30, 46, 0.4) !important;
}

@media (max-width: 600px) {
    .canjear-container {
        padding: 8px;
    }
    .premium-table >>> td {
        padding: 4px 8px !important;
    }
}
</style>